import React from 'react'

const Loading = () => {
    return (
        <div className='h-[calc(100vh-481px)] flex justify-center items-center text-white capitalize text-5xl font-bold'>
            <h1>Loading...</h1>
        </div>
    )
}

export default Loading